import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { StorageService } from '../services/storage.service';
import { AuthService } from '../services/auth.service';
import { AuthStateService } from '../services/auth-state.service';

export const associatedPatientsGuard = (): boolean | UrlTree => {
  const router = inject(Router);
  const storageService = inject(StorageService);
  const authService = inject(AuthService);
  const authStateService = inject(AuthStateService);

  if (!authStateService.isLoggedIn) {
    const signInTree = authService.createSignInUrlTree();
    return signInTree ?? router.createUrlTree(['/page-not-found']);
  }

  const associatedPatients = storageService.getSessionStorage('associated_patients');
  
  if (associatedPatients && Array.isArray(associatedPatients) && associatedPatients.length > 0) {
    return true;
  }

  const userInfo = authService.getUserInfo() || storageService.getSessionStorage('user_info');
  
  if (userInfo && userInfo.prid && userInfo.patientId) {
    router.navigate(['/home']);
    return false;
  }

  router.navigate(['/home']);
  return false;
};
